/**
 * Fonction utilitaire pour obtenir l'URL complète d'un fichier uploadé
 * @param {string} filename - Nom du fichier (ex: "logo_123.png")
 * @param {object} options - Options : { cacheBust: boolean }
 * @returns {string} URL complète vers le fichier
 */
export const getUploadUrl = (filename, options = {}) => {
  if (!filename) return '';
  
  // Si c'est déjà une URL complète, la retourner telle quelle
  if (filename.startsWith('http://') || filename.startsWith('https://')) {
    return filename;
  }
  
  // Obtenir l'URL de base du backend
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
  
  let url;
  if (API_URL.includes('localhost:8000')) {
    // En développement : URL absolue vers le backend
    url = `http://localhost:8000/uploads/${filename}`;
  } else {
    // En production : si l'API est sur le même domaine, utiliser un chemin relatif
    // (plus fiable, évite CORS et problèmes de cache)
    const baseUrl = API_URL.replace(/\/api\/v1\/?$/, '');
    try {
      const apiOrigin = new URL(baseUrl).origin;
      if (typeof window !== 'undefined' && window.location.origin === apiOrigin) {
        url = `/uploads/${filename}`;
      } else {
        url = `${baseUrl}/uploads/${filename}`;
      }
    } catch {
      url = `${baseUrl}/uploads/${filename}`;
    }
  }
  
  // Cache-busting pour forcer le rechargement après upload
  if (options.cacheBust) {
    url += (url.includes('?') ? '&' : '?') + 't=' + Date.now();
  }
  return url;
};

export default getUploadUrl;

